import React from 'react';
import { FaShieldAlt, FaLightbulb, FaHandsHelping, FaCheckCircle, FaIndustry, FaHardHat } from 'react-icons/fa';
import './About.css';

function About() {
  return (
    <div className="about-page-wrapper">
      {/* Background Ambience */}
      <div className="about-ambient-glow glow-1"></div>
      <div className="about-ambient-glow glow-2"></div>

      <div className="about-modern-container">

        {/* SECTION 1: HERO MANIFESTO */}
        <section className="about-hero">
          <h1 className="manifesto-heading">
            Safety isn't just a policy.<br />
            <span className="highlight-text">It's our DNA.</span>
          </h1>
          <p className="manifesto-subtext">
            At WeCare EHS Consultancy, we are architects of safer workplaces.
            We don't just inspect; we transform. We don't just train; we empower.
            Dedicated to raising the bar for industrial safety across India.
          </p>
        </section>

        {/* SECTION 2: WHAT WE DO (Grid) */}
        <section className="about-grid-section">
          <div className="section-header">
            <h2 className="section-title">Our Expertise.</h2>
            <div className="section-line"></div>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <FaHardHat className="service-icon" />
              <h3>Specialized Training</h3>
              <p>From Firefighting to Behavior Based Safety (BBS), we deliver immersive programs tailored for high-risk environments.</p>
            </div>

            <div className="service-card">
              <FaShieldAlt className="service-icon" />
              <h3>Compliance Audits</h3>
              <p>Rigorous evaluations including ISO 14001, 45001, 9001, and specialized construction & road safety audits.</p>
            </div>

            <div className="service-card">
              <FaIndustry className="service-icon" />
              <h3>Industrial Consultancy</h3>
              <p>End-to-end support for HAZOP studies, Risk Assessments (HIRA), and complete EHS management system implementation.</p>
            </div>
          </div>
        </section>

        {/* SECTION 3: VISION & MISSION (Split Layout) */}
        <section className="vision-mission-section">

          <div className="split-card vision-card">
            <div className="card-custom-content">
              <FaLightbulb className="card-icon" />
              <h2>Our Vision</h2>
              <p>
                To create a <strong>"Safe, Healthy & Accident-free Workplace"</strong> by elevating EHS competency globally.
                We aim to influence industry culture, reducing accidents and protecting both human life and national economic assets.
              </p>
            </div>
          </div>

          <div className="split-card mission-card">
            <div className="card-custom-content">
              <FaHandsHelping className="card-icon" />
              <h2>Our Mission</h2>
              <ul className="modern-list">
                <li><FaCheckCircle className="li-icon" /> Accident-free workplace environments</li>
                <li><FaCheckCircle className="li-icon" /> Sustainable business & environmental solutions</li>
                <li><FaCheckCircle className="li-icon" /> Competent EHS support systems</li>
                <li><FaCheckCircle className="li-icon" /> Building safety culture in society</li>
              </ul>
            </div>
          </div>

        </section>

        {/* SECTION 4: COMMITMENT FOOTER */}
        <section className="commitment-footer">
          <div className="commitment-content">
            <h2>Our Commitment</h2>
            <p>
              Transparency. Integrity. Quality. <br />
              We build relationships on trust and deliver consistent, life-saving results.
            </p>
          </div>
        </section>

      </div>
    </div>
  );
}

export default About;